var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEn = function SvgEn(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.625 20H4.375A4.375 4.375 0 0 1 0 15.625V4.375A4.375 4.375 0 0 1 4.375 0h11.25A4.375 4.375 0 0 1 20 4.375v11.25A4.375 4.375 0 0 1 15.625 20Z",
    fill: "#3B6FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 15.625v-.96l-3.103-2.033h3.102v-1.053h-8.42V20h1.052v-6.388l6.677 4.374c.236-.368.419-.774.537-1.206M.294 17.205c.107.275.24.537.397.782l6.677-4.375V20h1.053v-8.42H0v1.052h3.102L0 14.664v.961c0 .168.01.334.028.497M0 4.524v.812l3.102 2.032H0v1.053h8.421V0H7.368v6.388L.691 2.014a4.35 4.35 0 0 0-.57 1.334M19.7 2.78a4.358 4.358 0 0 0-.392-.766L12.63 6.388V0h-1.053v8.421H20V7.368h-3.102l3.102-2.032v-.961c0-.174-.01-.346-.03-.515",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.579 0H8.42v8.421H0v3.158h8.421V20h3.158v-8.421H20V8.42h-8.421V0Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.407 12.632-5.378 3.49c.043.378.134.741.266 1.083l7.045-4.573H5.407ZM13.455 12.632l6.39 4.148c.1-.368.154-.755.154-1.155l-4.61-2.993h-1.934ZM6.316 7.368.122 3.348C.042 3.678 0 4.02 0 4.375v.149l4.382 2.844h1.934ZM14.564 7.369 19.97 3.86a4.34 4.34 0 0 0-.27-1.08L12.631 7.37h1.933Z",
    fill: "#FF4B55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10Z",
    fill: "#fff"
  })))));
};
export default SvgEn;